import {
  addContactToEvent as addContactToEventCommon,
  createEvent as createEventCommon,
  deleteEvent as deleteEventCommon,
  removeContactFromEvent as removeContactFromEventCommon,
  updateEvent as updateEventCommon,
  type CreateEventPayload as CommonCreateEventPayload,
  type UpdateEventPayload as CommonUpdateEventPayload,
  type EventType,
} from '@aikoa/common'
import { supabase } from '~/lib/supabase'

export type CreateEventPayload = {
  assetId: string
  title: string
  description?: string | null
  eventType: EventType
  eventDate?: Date | null
}

export type UpdateEventPayload = {
  eventId: string
  title?: string
  description?: string | null
  eventType?: EventType
  eventDate?: Date | null
}

export async function createEvent(payload: CreateEventPayload) {
  const commonPayload: CommonCreateEventPayload = {
    assetId: payload.assetId,
    title: payload.title,
    description: payload.description,
    eventType: payload.eventType,
    eventDate: payload.eventDate,
  }

  return createEventCommon(commonPayload, supabase)
}

export async function updateEvent(payload: UpdateEventPayload) {
  const commonPayload: CommonUpdateEventPayload = {
    eventId: payload.eventId,
    title: payload.title,
    description: payload.description,
    eventType: payload.eventType,
    eventDate: payload.eventDate,
  }

  return updateEventCommon(commonPayload, supabase)
}

export async function deleteEvent(eventId: string) {
  return deleteEventCommon(eventId, supabase)
}

export async function addContactToEvent(eventId: string, contactId: string) {
  return addContactToEventCommon(eventId, contactId, supabase)
}

export async function removeContactFromEvent(eventId: string, contactId: string) {
  return removeContactFromEventCommon(eventId, contactId, supabase)
}
